import Content from './license.mdx'
import { mdxComponents } from '../components/MdxComponents'
import { Header } from '../components/Header'
import Head from 'expo-router/head'
import React from 'react'
import { getSiteUrl } from '@/utils/getSiteUrl'

export const unstable_settings = {
  // This component will be rendered at build-time and never re-rendered in production.
  render: 'static',
}

export default function License() {
  const pageUrl = `${getSiteUrl()}/license`

  return (
    <>
      <Head>
        <title>License - React Native Google Sign In</title>
        <meta name="description" content="React Native Google Sign In package license terms and conditions. Choose between personal and team licenses for your project." />
        <meta property="og:title" content="License - React Native Google Sign In" />
        <meta property="og:description" content="React Native Google Sign In package license terms and conditions." />
        <meta property="og:url" content={pageUrl} />
        <link rel="canonical" href={pageUrl} />
      </Head>
      <div className="h-full">
        <Header />
        <div className="p-4 max-w-3xl mx-auto">
          <Content components={mdxComponents} />
        </div>
      </div>
    </>
  )
}
